module.exports = __webpack_public_path__ + "static/img/logo.bb9f3d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = AqYs
// module chunks = 1